import { useParams } from 'react-router-dom';
import { useApiQuery } from '../api/useApiQuery';
import { ApiRequestError } from '../api/client';
import { DocumentViewer } from '../components/DocumentViewer';
import { ErrorBanner } from '../components/ui/ErrorBanner';
import { FullPageSpinner } from '../components/ui/Spinner';
import { NotFoundPage } from './NotFoundPage';

/** `/d/:documentId` — share links resolve through the same permission check as the folder view. */
export function DocumentPage() {
  const { documentId = '' } = useParams();
  const query = useApiQuery((api, signal) => api.documents.get(documentId, signal), [documentId]);

  if (query.loading) return <FullPageSpinner label="Loading document" />;
  if (query.error) {
    if (query.error instanceof ApiRequestError && query.error.isNotFound) return <NotFoundPage what="document" />;
    return <ErrorBanner title="Document could not be loaded" error={query.error} />;
  }
  if (!query.data) return null;
  return <DocumentViewer document={query.data} onChanged={query.reload} />;
}
